import React, { useContext, useEffect } from 'react';
import { ReviewsContext } from './ReviewsContext';

const SortOptionProvider = ({ children }) => {
  const { 
    sortOption, 
    setSelectedSubject, 
    setSelectedAttribute, 
    setSelectedCategory 
  } = useContext(ReviewsContext);

  // Reset filters when sort option changes
  useEffect(() => {
    setSelectedSubject(null);
    setSelectedAttribute(null);
    // Don't reset category when sort option changes
    // setSelectedCategory(null);
  }, [sortOption, setSelectedSubject, setSelectedAttribute, setSelectedCategory]);

  return children;
};

export default SortOptionProvider; 